<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0">
                    <multiselect
                        v-model="search.shift_id"
                        class="form-control border-0"
                        :options="optionShiftEmployee"
                        label="name"
                        :show-labels="false"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        track-by="id"
                        placeholder="ชื่อตารางการทำงาน">
                    </multiselect>
                    <multiselect
                        v-model="search.employee"
                        class="form-control border-0"
                        :options="optionEmployee"
                        :customLabel="labelEmployee"
                        :show-labels="false"
                        select-label=""
                        selectedLabel=""
                        deselectLabel=""
                        track-by="id"
                        placeholder="พนักงาน">
                    </multiselect>
                    <b-form-select
                        :options="optionActive"
                        v-model="search.active">
                    </b-form-select>
                    <date-picker
                        v-model="search.date"
                        type="date"
                        :format="changeFormat"
                        :lang="lang"
                        placeholder="วัน/เดือน/ปี ที่เปลี่ยน">
                    </date-picker>
                    &nbsp&nbsp
                    <button class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchWorkSchedule">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>
                    &nbsp
                    <button class="btn btn-green my-2 my-sm-0"
                            @click="showWorkScheduleModal"
                            type="button">
                        <icon name="calendar-alt"></icon>
                        ปรับตารางการทำงาน
                    </button>
                </form>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table style="text-align: center" class="table table-bordered">
                <thead>
                <tr>
                    <th scope="col">พนักงาน</th>
                    <th scope="col">สถานะ</th>
                    <th scope="col">ตารางการทำงานเดิม</th>
                    <th scope="col">ตารางการทำงานใหม่</th>
                    <th scope="col">เวลาใหม่</th>
                    <th scope="col">วัน/เดือน/ปี ที่เปลี่ยน</th>
                    <th scope="col">ผู้เปลี่ยนตารางการทำงาน</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data) in work_schedule_list">
                    <td class="text-left">
                        {{ data.employee ? data.employee.employee_no : '' }}
                        {{ data.employee ? data.employee.name : 'ทั้งกะ' }}
                    </td>
                    <td>
                        <template v-if="data.work_status">
                            {{ data.work_status.active_status_id == 1 ? 'พนักงาน' : (data.work_status.active_status_id == 2 ? 'ลาออก' : '-') }}
                        </template>
                    </td>
                    <td>
                        {{ data.old_shift_work ? data.old_shift_work.name : '-' }}
                    </td>
                    <td>
                        {{ data.new_shift_work ? data.new_shift_work.name : '-' }}
                    </td>
                    <td>
                        {{ data.start_work_time }} - {{ data.end_work_time }}
                    </td>
                    <td>
                        {{ data.date | moment("DD/MM/YYYY") }}
                    </td>
                    <td>
                        <template v-if="data.user">
                            {{ data.user.name }}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="showWorkSchedule(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>&nbsp;
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <br>
        <div v-if="work_schedule_list.length > 0">
            <vue-pagination :pagination="dataPaginate"
                            @paginate="getWorkSchedule">
            </vue-pagination>
        </div>
        <!--b-modal-->
        <b-modal hide-footer hide-header ref="work_schedule">
            <work-schedule-history-modal @submit="saveWorkSchedule">
            </work-schedule-history-modal>
        </b-modal>
        <b-modal hide-header hide-footer ref="delete_item">
            <delete-confirm-modal @submit="deleteWorkSchedule">
            </delete-confirm-modal>
        </b-modal>
        <b-modal hide-footer hide-header ref="loading">
            <div>
                <loading @submit="hideLoadingModal" :msg="msg" :status="loading_status"></loading>
            </div>
        </b-modal>
        <!--        <pre class="alert alert-primary">{{work_schedule_list}}</pre>-->
    </div>
</template>

<script>
import {mapState} from "vuex"
import Multiselect from "vue-multiselect";
import moment from "moment"
import DatePicker from 'vue2-datepicker'
import VuePagination from "../../../Pagination";
import WorkScheduleHistoryModal from "./WorkScheduleHistoryModal";
import DeleteConfirmModal from "../../../Utility/DeleteConfirmModal";
import Loading from "../../../Utility/Loading";

export default {
    name: "work-schedule-history",
    components: {
        Loading,
        DeleteConfirmModal,
        WorkScheduleHistoryModal,
        VuePagination,
        Multiselect,
        DatePicker
    },
    created() {
        this.$store.dispatch("Common/setShiftWorkEmployee");
        this.$store.dispatch("WorkScheduleHistory/setWorkScheduleHistory")
        this.$store.dispatch("WorkScheduleHistory/clearSearch")
        this.getEmployeeAll();
    },
    computed: {
        ...mapState({
            optionShiftEmployee: state => {
                return state.Common.shift_work_employee
            },
            work_schedule_list: state => {
                return state.WorkScheduleHistory.workScheduleList
            },
            user: state => {
                return state.Auth.user;
            },
            search: state => {
                return state.WorkScheduleHistory.search;
            },
            dataPaginate: state => {
                return state.WorkScheduleHistory.dataPaginate;
            },
        })
    },
    data() {
        return {
            loading_status: '',
            msg: '',
            old_shift: "",
            new_shift: "",
            event_submit: false,
            delete_id: '',
            optionEmployee: [],
            changeFormat: {
                stringify: (date) => {
                    if(date && moment(date).format('MM') == '02' && moment(date).format('DD') == '29')
                          return '29/02/' + moment(date).add(543, 'y').format('YYYY');
                      return date ? moment(date).add(543, 'y').format('DD/MM/YYYY') : null
                },
                parse: (value) => {
                    return value ? moment(value, 'DD/MM/YYYY').subtract(543, 'y').toDate() : null
                }
            },
            lang: {
                days: ['อา', 'จ', 'อ', 'พ', 'พฤ', 'ศ', 'ส'],
                months: ['มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน', 'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'],
                pickers: ['ถัดไป 7 วัน', 'ถัดไป 30 วัน', 'ก่อนหน้า 7 วัน', 'ก่อนหน้า 30 วัน'],
                placeholder: {
                    date: 'วว/ดด/ปปปป',
                }
            },
            optionActive: [
                {text: "เลือกสถานะ", value: ""},
                {text: 'พนักงาน', value: 1},
                {text: 'ลาออก', value: 2},
            ],
        }
    },
    methods: {
        labelEmployee(option) {
            return `${option.employee_no} - ${option.name}`
        },
        showWorkScheduleModal() {
            this.$refs.work_schedule.show();
        },
        hideWorkScheduleModal() {
            this.$refs.work_schedule.hide();
        },
        showDeleteModal(id) {
            this.delete_id = id;
            this.$refs.delete_item.show();
        },
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        hideDeleteModal() {
            this.$refs.delete_item.hide();
        },
        searchWorkSchedule() {
            this.event_submit = true;
            //change date format
            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }

            let data = {
                shift_id: "",
                date: this.search.date,
                employee_id: this.search.employee ? this.search.employee.id : '',
                active: this.search.active,
            };

            if (this.search.shift_id) {
                data.shift_id = this.search.shift_id.id;
            }
            this.$store.dispatch("WorkScheduleHistory/search", data)
        },
        getEmployeeAll() {
            this.$store.dispatch("Employee/getEmployeeAll").then(employee => {
                this.optionEmployee = employee;
            });
        },
        getWorkSchedule() {
            const page = this.dataPaginate.current_page;

            if (this.search.date) {
                this.search.date = moment(this.search.date).format("YYYY-MM-DD");
            } else {
                this.search.date = "";
            }

            let data = {
                page: page,
                shift_id: "",
                date: this.search.date,
                employee_id: this.search.employee ? this.search.employee.id : '',
                active: this.search.active,
            };

            if (this.search.shift_id) {
                data.shift_id = this.search.shift_id.id;
            }
            //paginate search
            if (this.event_submit) {
                this.$store.dispatch('WorkScheduleHistory/search', data)
            }
            //paginate get data
            else {
                this.$store.dispatch('WorkScheduleHistory/setWorkScheduleHistory', page)
            }
        },
        saveWorkSchedule(value) {
            if (value) {
                this.showLoadingModal();
                this.loading_status = 1;
                this.msg = 'กรุณารอสักครู่';
                if (value.id) {
                    this.$store.dispatch("WorkScheduleHistory/update", {
                        id: value.id,
                        data: value,
                    }).then(() => {
                        this.msg = 'อัพเดทสำเร็จ';
                        this.loading_status = 2;
                        this.getWorkSchedule();
                    });
                } else {
                    this.$store.dispatch("WorkScheduleHistory/create", value).then(() => {
                        this.$store.dispatch('WorkScheduleHistory/setWorkScheduleHistory', 1)
                        this.msg = 'เพิ่มสำเร็จ';
                        this.loading_status = 2;
                    });
                }
            }
            this.hideWorkScheduleModal();
            this.$store.dispatch("WorkScheduleHistory/clearForm");
        },
        deleteWorkSchedule(value) {
            if (value) {
                this.showLoadingModal();
                this.loading_status = 1;
                this.msg = 'กรุณารอสักครู่';
                this.$store.dispatch("WorkScheduleHistory/delete", this.delete_id).then(() => {
                    this.loading_status = 2;
                    this.msg = 'ลบรายการสำเร็จ';
                    this.getWorkSchedule();
                }).catch(err => {
                    //console.log(err);
                    this.showLoadingModal();
                    this.loading_status = 3;
                    this.msg = 'ลบรายการไม่สำเร็จ';
                });
            } else {
                this.hideDeleteModal();
            }

        },
        showWorkSchedule(id) {
            this.$store.dispatch("WorkScheduleHistory/show", id).then(() => {
                this.showWorkScheduleModal();
            })
        },
    }
}
</script>

<style scoped>
.btn-green {
    background-color: #00a699;
    color: white;
}
</style>
